/**
 * Trader Journal API functions
 */
import { ENDPOINTS } from './endpoints';
import { getRequestBackendDataV2, postRequestBackendDataV2 } from './core';

export async function getJournalEntriesV2(auth, callback, limit = 20, offset = 0, methodAnalytics = 'all', accountId = null) {
    await getRequestBackendDataV2(auth, callback, ENDPOINTS.JOURNAL.ENTRIES(limit, offset, methodAnalytics, accountId));
}

export async function getJournalEntryV2(auth, callback, entryId) {
    await getRequestBackendDataV2(auth, callback, ENDPOINTS.JOURNAL.ENTRY(entryId));
}

export async function createJournalEntryV2(auth, callback, entry) {
    // Ensure trade_date is in milliseconds
    const entryData = {
        ...entry,
        trade_date: entry.trade_date || Date.now()
    };
    await postRequestBackendDataV2(auth, callback, ENDPOINTS.JOURNAL.ENTRIES_BASE, entryData);
}

export async function updateJournalEntryV2(auth, callback, entryId, entry) {
    // Ensure trade_date is in milliseconds
    const entryData = {
        ...entry,
        trade_date: entry.trade_date || Date.now()
    };
    await postRequestBackendDataV2(auth, callback, ENDPOINTS.JOURNAL.ENTRY(entryId), entryData, 'PUT');
}

export async function deleteJournalEntryV2(auth, callback, entryId) {
    await postRequestBackendDataV2(auth, callback, ENDPOINTS.JOURNAL.ENTRY(entryId), {}, 'DELETE');
}

export async function getJournalStatisticsV2(auth, callback, methodAnalytics = 'all', accountId = null) {
    await getRequestBackendDataV2(auth, callback, ENDPOINTS.JOURNAL.STATISTICS(methodAnalytics, accountId));
}

// Journal Account API functions
export async function getJournalAccountsV2(auth, callback) {
    await getRequestBackendDataV2(auth, callback, ENDPOINTS.JOURNAL.ACCOUNTS);
}

export async function createJournalAccountV2(auth, callback, account) {
    await postRequestBackendDataV2(auth, callback, ENDPOINTS.JOURNAL.ACCOUNTS, account);
}

export async function updateJournalAccountV2(auth, callback, accountId, account) {
    await postRequestBackendDataV2(auth, callback, ENDPOINTS.JOURNAL.ACCOUNT(accountId), account, 'PUT');
}

export async function deleteJournalAccountV2(auth, callback, accountId) {
    await postRequestBackendDataV2(auth, callback, ENDPOINTS.JOURNAL.ACCOUNT(accountId), {}, 'DELETE');
}

// Webhook API functions
export async function updateAccountWebhookEnabled(auth, callback, accountId, enabled) {
    await postRequestBackendDataV2(auth, callback, ENDPOINTS.JOURNAL.ACCOUNT_WEBHOOK(accountId), { enabled }, 'PATCH');
}

export async function regenerateAccountWebhookSecret(auth, callback, accountId) {
    await postRequestBackendDataV2(auth, callback, ENDPOINTS.JOURNAL.ACCOUNT_WEBHOOK_REGENERATE(accountId), {});
}

export async function getAccountWebhookInfo(auth, callback, accountId) {
    await getRequestBackendDataV2(auth, callback, ENDPOINTS.JOURNAL.ACCOUNT_WEBHOOK(accountId));
}

// Instrument-specific webhook API functions
export async function getWebhooks(auth, callback) {
    await getRequestBackendDataV2(auth, callback, ENDPOINTS.JOURNAL.WEBHOOKS);
}

export async function getWebhooksForAccount(auth, callback, accountId) {
    await getRequestBackendDataV2(auth, callback, ENDPOINTS.JOURNAL.WEBHOOKS_FOR_ACCOUNT(accountId));
}

export async function createWebhook(auth, callback, accountId, instrument) {
    await postRequestBackendDataV2(auth, callback, ENDPOINTS.JOURNAL.WEBHOOKS, {
        accountId,
        instrument
    });
}

export async function updateWebhook(auth, callback, webhookId, enabled) {
    await postRequestBackendDataV2(auth, callback, ENDPOINTS.JOURNAL.WEBHOOK(webhookId), {
        enabled
    }, 'PATCH');
}

export async function regenerateWebhookSecret(auth, callback, webhookId) {
    await postRequestBackendDataV2(auth, callback, ENDPOINTS.JOURNAL.WEBHOOK_REGENERATE(webhookId), {});
}

export async function deleteWebhook(auth, callback, webhookId) {
    await postRequestBackendDataV2(auth, callback, ENDPOINTS.JOURNAL.WEBHOOK(webhookId), {}, 'DELETE');
}

